import React from "react";
import { Switch, Tag } from "antd";
import { fullMediaUrl } from "../../Functionalities/fullMediaUrl";

const PAGE_SIZE = 50;

const Picture = ({ row }) => {
  const src = fullMediaUrl(row.image || row.fallback_image);
  return src ? <img className="umb-picture" src={src} alt="" /> : <span className="umb-picture umb-picture--letter">{row.name.charAt(0)}</span>;
};

const Row = ({ row, onHide, onRename, onMerge }) => (
  <tr>
    <td><Picture row={row} /></td>
    <td>
      <span className="umb-name">
        {row.name}
        {row.needs_review && <Tag color="orange">Review</Tag>}
        {!row.image && row.fallback_image && <Tag>Dish photo</Tag>}
      </span>
    </td>
    <td>{row.products}</td>
    <td>{row.franchises}</td>
    <td><Switch checked={row.hide_from_home} onChange={(checked) => onHide(row, checked)} /></td>
    <td>
      <span className="umb-actions">
        <button type="button" className="btn btn-light btn-sm" onClick={() => onRename(row)}>Rename</button>
        <button type="button" className="btn btn-light btn-sm" onClick={() => onMerge(row)}>Merge</button>
      </span>
    </td>
  </tr>
);

export default function UmbrellaTable({ data, page, loading, onPage, ...actions }) {
  const pages = Math.max(1, Math.ceil(data.count / PAGE_SIZE));
  return (
    <>
      <div className="umb-scroll">
        <table className="umb-table">
          <thead>
            <tr>
              <th aria-label="Picture" />
              <th>Category</th>
              <th>Products</th>
              <th>Franchises</th>
              <th>Hide from home</th>
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {data.results.map((row) => <Row key={row.id} row={row} {...actions} />)}
          </tbody>
        </table>
        {!loading && data.results.length === 0 && <p className="umb-muted umb-empty">No categories here.</p>}
      </div>
      <div className="umb-pages">
        <button type="button" className="btn btn-light btn-sm" disabled={page <= 1 || loading} onClick={() => onPage(page - 1)}>Previous</button>
        <span className="umb-muted">{loading ? "Loading…" : `Page ${page} of ${pages} · ${data.count} categories`}</span>
        <button type="button" className="btn btn-light btn-sm" disabled={page >= pages || loading} onClick={() => onPage(page + 1)}>Next</button>
      </div>
    </>
  );
}
